import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20artistic%20wide%20banner%2C%20stylized%20comic%20panel%20texture%20with%20warm%20coral%20and%20cream%20gradient%2C%20soft%20abstract%20brush%20strokes%2C%20ethereal%20atmosphere%2C%20subtle%20Korean%20decorative%20elements%2C%20cinematic%20lighting%2C%20dreamy%20artistic%20illustration%2C%20no%20text%2C%20clean%20negative%20space&width=1600&height=600&seq=cta-banner-manhwa&orientation=landscape"
            alt=""
            className="w-full h-64 md:h-80 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/60 to-foreground-900/20"></div>

          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3 leading-tight">
              准备好开始你的
              <span className="text-accent-500 font-heading italic"> 阅读之旅 </span>
              了吗？
            </h2>
            <p className="text-background-100/80 text-sm md:text-base mb-8 max-w-md">
              加入数百万韩漫爱好者，畅享极速阅读体验
            </p>
            <Link
              to="/category/romance"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-label font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
            >
              立即开始阅读
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}